import { Alert, Button, Form, Space, Typography } from 'antd'
import AuthorisedContainer from 'components/AuthorisedContainer'
import { PermissionSetMap } from 'constants/RBACConstants'
import React, { forwardRef, useCallback, useEffect,useState } from 'react'
import { FieldTypes, generateFormFields } from 'utils/formUtils'
import { useGlobalFilterContext } from 'contexts/GlobalFilterContext';
import { isUndefined } from 'lodash'
import { CoverityIssueKindAPI } from 'restAPI/ToolsIntegrationAPI'

const CoverityIssueKindSelection = forwardRef(({toolName},ref) => {
    const [form] = Form.useForm();
    const { globalFilterHash } = useGlobalFilterContext();
    const [initialIssueKinds,setInitialIssueKind]=useState([]);

    const fetchInitialData = useCallback(async()=>{
        try{
            let response = await CoverityIssueKindAPI.getAvailableIssueKind().promise;
            setInitialIssueKind(response);
        }
        catch(err){
            console.error(err);
        }
    },[])

    
    const fetchData = useCallback(async ()  => {
        try{
            let resData = await CoverityIssueKindAPI.getConfiguredIssueKind().promise;
            if (!isUndefined(resData)) {
                form.setFieldsValue({"issueKind":resData})
            }
        } catch(err) {
            console.error(err)
        }
    }, [form])

    useEffect(() => {
        fetchInitialData();
        fetchData();
    }, [globalFilterHash, fetchData,fetchInitialData])

    const fields = [{
        name: "issueKind",
        label:"Issue Kind",
        type: FieldTypes.MULTI_SELECT,
        placeholder:"Issue Kind",
        permission:PermissionSetMap.UPDATE_SLA,
        required:true,
        options:initialIssueKinds
    }]


    const onReset = useCallback(async() => {
            form.setFieldsValue({issueKind:initialIssueKinds});
      },[form,initialIssueKinds]);



    return (
        <Space direction="vertical" className="m-b-m">
            <Typography.Text>Select the {toolName} Issue Kind to ingest into Armorcode</Typography.Text>
            <Alert 
                description={
                    <Form 
                        form={form}
                        ref={ref}
                        style={{minWidth:400}} 
                        layout="vertical"
                    >
                        {generateFormFields(fields)}

                        <Form.Item className="text-right p-x-sm" >
                            <AuthorisedContainer permission={PermissionSetMap.UPDATE_SLA}>
                                <Button type="primary" onClick={onReset}>Reset</Button>
                            </AuthorisedContainer>
                         </Form.Item>    
                    </Form>
                } 
            />
        </Space>
    )
})

export default CoverityIssueKindSelection
